import script from "./AudioControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioControls.vue?vue&type=script&setup=true&lang=ts"

import "./AudioControls.vue?vue&type=style&index=0&id=dc785192&lang=scss"

const __exports__ = script;

export default __exports__